export const proceduresColumns = ['r1_id', 'account_number', 'procedure_code', 'is_flat_file_source'];
